import React from 'react';
import CarrierAccountsPanel from '@/components/CarrierAccountsPanel';

export default function SellerCarrierAccounts() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-5xl mx-auto p-6">
        <div className="mb-2 text-xs text-neutral-500">판매자 설정 › 택배 / 배송</div>
        <CarrierAccountsPanel scope="seller" testidPrefix="seller" />
      </div>
    </div>
  );
}
